<template>
  <div>
    <div v-if="$page.props.auth.user.type === 'ADMIN'" class="mb-4">
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/organizations">
          <icon name="users" class="mr-2 w-4 h-4" :class="isUrl('organizations') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Organizations</div>
        </Link>
      </div>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/projects">
        <icon name="document" class="mr-2 w-4 h-4" :class="isUrl('projects') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('projects') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Projects</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/comments">
        <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('comments') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('comments') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Comments</div>
      </Link>
    </div>
    <div class="mb-4">
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/users">
          <icon name="users" class="mr-2 w-4 h-4" :class="isUrl('users') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Users</div>
        </Link>
      </div>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/streams">
        <icon name="stream" class="mr-2 w-4 h-4" :class="isUrl('streams') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('streams') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Streams</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/recordings">
        <icon name="play" class="mr-2 w-4 h-4" :class="isUrl('recordings') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('recordings') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Recordings</div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
